import type { SVGProps } from 'react';
const SiMicrochip = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.75 8.75v6.5a2 2 0 0 0 2 2h6.5a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2h-6.5a2 2 0 0 0-2 2Zm2-2.25V4.75m6.5 1.75V4.75m-6.5 14.5v-1.5m6.5 1.5v-1.5m2.25-9h1.75m-14.5 0h1.5m11.25 6.5h1.75m-14.5 0h1.5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.75 9.75v4.5h4.5v-4.5h-4.5Z"
    />
  </svg>
);
export default SiMicrochip;
